export default "__VITE_ASSET__Bc4q7OQI__"